export default __webpack_public_path__ + "static/bg_header_sp-60bc5fdd37fc50c544a25e1b59c6511f.png";